<template>
  <div class="storeInfo">
    <ul>
      <li class="head">
        <img v-if="store.head_path" :src="store.head_path" @error="function(event) {let img = event.srcElement;img.src = errorHeadImg; img.onerror = null;}">
        <img v-if="!store.head_path" :src="errorHeadImg">
        <div class="title">
          <b>{{store.shop_name}}</b>
          <p>{{store.ck_smallname}}</p>
        </div>
      </li>
      <li class="weixin">
        <p v-if="store.weixin"><b>微信</b><i>{{store.weixin}}</i></p>
        <p v-if="store.mobile"><b>电话</b><i>{{store.mobile}}</i></p>
          <!--<span>复制</span>-->
      </li>
      <!--<li class="phone" v-if="store.mobile">-->
        <!--<p><b>电话</b><i>{{store.mobile}}</i></p>-->
      <!--</li>-->
      <li class="zhsh" v-if="store.cerpath">
        <p>资质证书</p>
        <div class="certificate">
          <img v-if="store.cerpath" :src="store.cerpath">
          <!--<span v-show="false">证书图片</span>-->
        </div>
      </li>
      <li class="zhsh" v-if="store.license">
        <p>营业执照</p>
        <div class="certificate">
          <img v-if="store.license" :src="store.license">
          <!--<span v-show="false">证书图片</span>-->
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { isWeixin, fenxiang } from '../../assets/common/js/config'

export default {
  name: 'storeInfo',
  data () {
    return {
      store: {}
    }
  },
  mounted: function () {
    this.getData()
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  methods: {
    getData: function () {
      var url = this.$ajax.getShopInfo_URL
      this.$customRequestAjax(url).then(res => {
        if (res.data.code === 200) {
          this.store = res.data
          if (isWeixin()) {
            fenxiang({path: 'storeinfo'})
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.storeInfo {
  ul {
    li{
      background: #fff;
      border-radius: 0.03rem;
      overflow: hidden;
      margin: 0.1rem 0.11rem 0;
      padding: 0.14rem 0.15rem;
      &.head {
        img {
          width: 0.46rem;
          height: 0.46rem;
          border-radius: 0.23rem;
          float: left;
        }
      }
      .title {
        float: left;
        padding-top: 0.04rem;
        margin-left: 0.08rem;
        b {
          display: block;
          font-size:0.14rem;
          font-family:'PingFangSC';
          font-weight:600;
          color:rgba(41,41,41,1);
          line-height:0.2rem;
        }
        p {
          margin-top: 0.02rem;
          font-size:0.12rem;
          font-family:'PingFangSC';
          font-weight:400;
          color:rgba(108,108,108,1);
          line-height:0.17rem;
        }
      }
      &.weixin {
        padding: 0 0.15rem;
        >p {
          font-size:0.13rem;
          line-height:0.18rem;
          padding: 0.13rem 0;
          &:after {
            content: '';
            display: block;
            clear: both;
          }
          &:nth-of-type(2) {
            border-top: 0.01rem solid #D8D8D8;
          }
          b {
            font-weight:600;
            color:rgba(0,0,0,1);
            float: left;
          }
          i {
            font-style: normal;
            font-weight:400;
            color:rgba(108,108,108,1);
            float: left;
            margin-left: 0.24rem;
            margin-right: 0.1rem;
          }
          span {
            font-size:0.12rem;
            font-weight:400;
            color:rgba(74,144,226,1);
            line-height:0.17rem;
            float: left;
          }
        }
      }
      &.zhsh {
        p {
          font-size:0.13rem;
          font-family:'PingFangSC';
          font-weight:600;
          color:rgba(0,0,0,1);
          line-height:0.18rem;
          border-bottom: 0.01rem solid #D8D8D8;
          padding-bottom: 0.1rem;
          margin-bottom: 0.15rem;
          overflow: hidden;
        }
        .certificate {
          width: 100%;
          /*height: 2.64rem;*/
          background:rgba(216,216,216,1);
          img {
            width: 100%;
            /*height: 100%;*/
          }
          span {
            display: block;
            font-size:0.18rem;
            font-family:'PingFangSC';
            font-weight:400;
            color:rgba(108,108,108,1);
            line-height:2.64rem;
            text-align: center;
          }
        }
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/storeInfo.vue